module.exports = __webpack_public_path__ + "img/Comercial_Build.6bfb103f.png";